module.exports = __webpack_public_path__ + "img/beijingtu (1).24ead95c.png";